module.exports = __webpack_public_path__ + "img/command.0fed6ddf.svg";